export const login = {
    "login_title_login": "Login",
    "login_title_register": "Create Account",
    "login_title_reset": "Reset Password",
    "login_field_username": "Username",
    "login_field_email": "Email",
    "login_field_register_coder": "Invitation Code",
    "login_placeholder_register_coder": "Enter Invitation Code",
    "login_error_invalid_register_coder": "Error invalid register coder.",
    "login_field_verification_code": "Verification Code",
    "login_field_password": "Password",
    "login_field_confirm_password": "Confirm Password",
    "login_placeholder_username": "Enter username",
    "login_placeholder_email": "Enter email",
    "login_placeholder_verification_code": "Enter verification code",
    "login_placeholder_password": "Enter password",
    "login_placeholder_confirm_password": "Confirm password",
    "login_action_login": "LOGIN",
    "login_action_register": "REGISTER",
    "login_action_reset": "RESET PASSWORD",
    "login_action_get_code": "Get Code",
    "login_link_forgot_password": "Forgot password?",
    "login_link_go_register": "Go to Register",
    "login_error_no_email": "Please enter your email",
    "login_error_code_failed": "Failed to send verification code",
    "login_error_username_required": "Username is required",
    "login_error_invalid_email": "Invalid email",
    "login_error_verification_code_required": "Verification code is required",
    "login_error_password_required": "Please enter password",
    "login_error_confirm_password": "Confirm your password",
    "login_error_password_mismatch": "Passwords do not match",
    "login_error_general": "An error occurred",
    "login_success_code_sent": "Verification code sent",
    "login_success_registered": "Registration successful",
    "login_success_reset": "Password reset successful",
    "login_countdown": "s",
    "reset_init_password_title": "Reset Password",
    "reset_init_password_field_new_password": "New Password",
    "reset_init_password_field_confirm_password": "Confirm New Password",
    "reset_init_password_field_email": "Email Address",
    "reset_init_password_field_email_code": "Verification Code",
    "reset_init_password_placeholder_new_password": "Enter new password",
    "reset_init_password_placeholder_confirm_password": "Enter new password again",
    "reset_init_password_placeholder_email": "Enter email address",
    "reset_init_password_placeholder_email_code": "Enter email verification code",
    "reset_init_password_error_new_password_required": "Please enter new password",
    "reset_init_password_error_confirm_password_required": "Please enter new password again",
    "reset_init_password_error_password_mismatch": "Passwords do not match",
    "reset_init_password_error_email_required": "Please enter email address",
    "reset_init_password_error_email_invalid": "Please enter a valid email address",
    "reset_init_password_error_email_code_required": "Please enter verification code",
    "reset_init_password_error_email_code_length": "Verification code should be 6 digits",
    "reset_init_password_action_reset": "Reset Password",
    "reset_init_password_action_send_email": "Send Verification Email",
    "reset_init_password_countdown_wait": "Please wait {{seconds}} seconds",
    "reset_init_password_error_password_mismatch_msg": "Passwords do not match",
    "reset_init_password_success": "Password reset successful",
    "reset_init_password_error_failed": "Password reset failed",
    "reset_init_password_error_get_user_failed": "Failed to get user information",
    "reset_init_password_error_email_invalid_msg": "Please enter a valid email address",
    "reset_init_password_success_email_sent": "Reset email sent successfully, please check your email",
    "reset_init_password_error_email_send_failed": "Failed to send email"
};
